import axios from "axios";
import { startOfQuarter,parse,format } from "date-fns";

const state = {
	locations: [],

};

const actions = {


	async loadLocations(context,list_id){

		return axios.get("/api/1/admissionSort", {
			params: {list_id:list_id}
		}).then(function(response){
			context.commit("setLocations",response.data.result);
		});

	},

	updateLocations(context,locations){
		context.commit("setLocations",locations)
	},


	rankChangeEvent(context,event){

		var list_id = event.list_id;

		if(context.rootState.list.currentList.list_id == list_id&&context.rootState.admissions.admissionsParams.list_id){

			actions.loadLocations(context,list_id);

		}

	},

	sectionEvent(context,event){

		var list_id = event.list_id;

		if(context.rootState.list.currentList.list_id == list_id&&context.rootState.admissions.admissionsParams.list_id){

			actions.loadLocations(context,list_id);

		}

	},


}

const mutations = {

	setLocations(state,data){
		state.locations = data;
	},

}

const getters = {

	locations(state){
		return state.locations;
	}
};
  

export default {
    state,
    actions,
    mutations,
    getters
};